export default __webpack_public_path__ + "static/media/raebe-raebeliechtli.ceb2c642.png";